import React from 'react';
import { Mui } from '@osu/react-ui';

/**
 * LoadingSkeleton Component
 * Displays loading placeholders while data is being fetched
 */
function LoadingSkeleton() {
  return (
    <Mui.Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header skeleton */}
      <Mui.Box sx={{ mb: 4 }}>
        <Mui.Skeleton variant="text" width="40%" height={48} sx={{ mb: 1 }} />
        <Mui.Skeleton variant="text" width="25%" height={24} />
      </Mui.Box>

      {/* Main content skeleton */}
      <Mui.Paper elevation={2} sx={{ p: 4, mb: 4 }}>
        {/* Timeline steps skeleton */}
        {[1, 2, 3].map((step) => (
          <Mui.Box key={step} sx={{ display: 'flex', mb: 4 }}>
            {/* Step icon */}
            <Mui.Box sx={{ mr: 3, mt: 1 }}>
              <Mui.Skeleton variant="circular" width={48} height={48} />
            </Mui.Box>
            
            {/* Step content */}
            <Mui.Box sx={{ flex: 1 }}>
              <Mui.Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
              <Mui.Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
              <Mui.Skeleton variant="text" width="80%" height={20} sx={{ mb: 2 }} />
              
              {/* Action buttons skeleton */}
              <Mui.Box sx={{ display: 'flex', gap: 2 }}>
                <Mui.Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
                <Mui.Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
              </Mui.Box>
            </Mui.Box>
          </Mui.Box>
        ))}
      </Mui.Paper>
    </Mui.Container>
  );
}

export default LoadingSkeleton;